import { render, staticRenderFns } from "./EditSimple.vue?vue&type=template&id=c187845e"
import script from "./EditSimple.vue?vue&type=script&lang=js"
export * from "./EditSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports